import getDecorators from 'inversify-inject-decorators';

import { rootContainer } from '../ioc';

import { StatementStore } from './stores/statement.store';
import { ChargeStore } from './stores/charge.store';
import { PaymentGateway } from './stores/payment-gateway.store';
import { SavedCreditCardsStore } from 'src/payment-method/stores/saved-credit-cards.store';
import { SavedPaymentMethodsStore } from 'src/payment-method/stores/saved-payment-methods.store';

export const statementContainer = rootContainer.createChild();
export const { lazyInject } = getDecorators(statementContainer);

statementContainer.bind(StatementStore).toSelf().inSingletonScope();
statementContainer.bind(ChargeStore).toSelf().inSingletonScope();
statementContainer.bind(PaymentGateway).toSelf().inSingletonScope();
statementContainer.bind(SavedCreditCardsStore).toSelf().inSingletonScope();
statementContainer.bind(SavedPaymentMethodsStore).toSelf().inSingletonScope();